import { IconButton, Menu, MenuItem, useTheme } from '@mui/material'
import { History } from 'assets/Icon';
import React from 'react'
import { useNavigate } from 'react-router-dom';

function HistoryButton() {
  const theme = useTheme()

  const navigate = useNavigate()

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <IconButton
        aria-label="history"
        size="small"
        sx={{ ml: 1 }}
        onClick={handleClick}
      >
        <History color={theme.palette.secondary.main} />
      </IconButton>

      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        <MenuItem onClick={() => navigate("/history/basket-history")}>Wallet History</MenuItem>
        <MenuItem onClick={() => navigate("/history/request-history")}>Request History</MenuItem>
      </Menu>
    </>
  )
}

export default HistoryButton